//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex'
import { } from 'k12vux'
import { } from 'k12lib'
import pcHeader from '../../components/pc/pcHeader'
import pcFooter from '../../components/pc/pcFooter'
import { isEmpty } from 'lodash'

export default {
  components: {
    pcHeader,
    pcFooter
  },
  async created () {
    this.$wisLoading(false)
  },
  async mounted () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isEmpty,
      bgxtList: [
        [
          {
            img: 'icon1',
            appList: [ '校历', '部门通知', '问卷调查', '考勤请假' ]
          },
          {
            img: 'icon2',
            appList: [ '设备采购入库', '领用借用', '设备扫码报修', '维修评价' ]
          },
          {
            img: 'icon3',
            appList: [ '会议室预定', '会议通知提醒', '会议签到', '会务资料' ]
          }
        ],
        [
          {
            img: 'icon4',
            appList: [ '事务申请', '用车申请', '用章申请' ]
          },
          {
            img: 'icon5',
            appList: [ '用款申请', '工资查询', '校园支付' ]
          },
          {
            img: 'icon6',
            appList: [ '校园巡查', '访客申请' ]
          }
        ]
      ],
      xttdList: [
        [
          {
            img: 'featuer1',
            name: '管理',
            featuer: '高效有序',
            descList: [
              '行政审批流程、教育管理流程网上有序进行',
              '任务自动分拆，流程自动督促，多人协同推进',
              '使用手机随时随地处理'
            ]
          },
          {
            img: 'featuer2',
            name: '校务',
            featuer: '清晰明了',
            descList: [
              '校领导：学校各项事务执行情况了如指掌',
              '部门：各项流程进展情况实施跟踪推进',
              '教师：申请批量、教学任务、实施提醒',
              '家长：消息提醒、在校情况、手机全掌握'
            ]
          }
        ],
        [
          {
            img: 'featuer3',
            name: '消息',
            featuer: '快速传递',
            descList: [
              '通知一键必达，代办及时提醒',
              '根据通讯录快速建群，交流通畅有序',
              '文件、图片、视频、语音快速共享'
            ]
          },
          {
            img: 'featuer4',
            name: '系统',
            featuer: '易用实用',
            descList: [
              '类似微信的操作方法，符合用户习惯',
              '实用快速上手，免培训',
              '对应日常事务，实用价值显著'
            ]
          }
        ],
        [
          {
            img: 'featuer5',
            name: '智慧校园',
            featuer: '一站访问',
            descList: [
              '师生家长一站式访问智慧校园各类应用',
              '支持智慧校园新老应用接入',
              '支持应用数据的对接共享'
            ]
          },
          {
            img: 'featuer6',
            name: '平台',
            featuer: '安全稳定',
            descList: [
              '企业级安全防护体系',
              '保障数据不丢失、不泄密',
              '师生无论在校在家，均可高速访问'
            ]
          }
        ],
        [
          {
            img: 'featuer7',
            name: '实用',
            featuer: '门槛低',
            descList: [
              '学校无需准备服务器等复杂运行环境',
              '开通后即可使用',
              '用户通过手机、pad、电脑均可访问'
            ]
          },
          {
            img: 'featuer8',
            name: '服务',
            featuer: '高质量',
            descList: [
              '服务专员为学校提供全程技术服务，全年无休',
              '解决学校信息化应用推进的后顾之优',
              '学校购买服务，可持续发展的基石'
            ]
          }
        ]
      ]
    }
  },
  computed: {
    ...mapState('common', []),
    ...mapGetters('common', [])
  },
  watch: {},
  filters: {},
  methods: {
    ...mapActions('common', []),

    handleView (path) {
      this.$router.push({
        path
      })
    }
  }
}
